/*
 * @Description: Vue 3 升级版入口文件
 * @Author: 王天琦
 * @Date: 2022-06-08 08:46:50
 * @Updated: 2024 - Vue 3 升级
 */
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
// 引入 Element Plus 图标（如果使用）
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import { ElMessage as Message, ElMessageBox as MessageBox } from 'element-plus'
import axios from "axios"
import EchartsDemo from "./components/echarts"
import htmlToPdf from './utils/htmlToPdf'
import comm from './commonjs/comm'
import Echarts1Demo from "./components/echarts1"
import Echarts2Demo from "./components/echarts2"
import './utils/rem.js'
import highcharts from 'highcharts'

// 移除 highcharts-vue 导入，改用原生方式
// import VueHighCharts from 'highcharts-vue'
import highcharts3d from 'highcharts/highcharts-3d'

highcharts3d(highcharts)

// 动态读取配置文件
import configService from './services/configService'

// 创建 Vue 应用实例
const app = createApp(App)

// 注册 Element Plus 图标组件（如果使用）
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

// 注册全局属性和方法
app.config.globalProperties.$axios = axios
app.config.globalProperties.comm = comm
app.config.globalProperties.$returnCitySN = window.returnCitySN
app.config.globalProperties.$message = Message

// MessageBox API 包装
app.config.globalProperties.$msgbox = MessageBox
app.config.globalProperties.$alert = (message, title, options) => {
    return MessageBox.alert(message, title || '提示', options)
}
app.config.globalProperties.$confirm = (message, title, options) => {
    return MessageBox.confirm(message, title || '提示', options || {})
}
app.config.globalProperties.$prompt = (message, title, options) => {
    return MessageBox.prompt(message, title || '提示', options || {})
}

// 添加配置工具到 Vue 原型
import configUtils from './utils/configUtils'
app.config.globalProperties.$config = configUtils

// 使用插件
app.use(ElementPlus)
app.use(EchartsDemo)
app.use(Echarts1Demo)
app.use(Echarts2Demo)
app.use(htmlToPdf)
app.use(router)
app.use(store)

// 初始化配置服务并应用到axios
configService.applyAxiosConfig().then(config => {
  console.log('配置加载完成，baseURL:', config.baseURL);
  // 配置加载完成后再挂载应用
  app.mount('#app');
  // 检查是否需要在页面刷新后重定向
  setTimeout(() => {
    const redirectPath = localStorage.getItem('redirectAfterReload');
    if (redirectPath) {
      localStorage.removeItem('redirectAfterReload');
      router.push(redirectPath);
    }
  }, 100);
}).catch(error => {
  console.error('配置加载失败:', error);
  // 即使配置加载失败，也尝试挂载应用，使用默认配置
  app.mount('#app');
  // 检查是否需要在页面刷新后重定向
  setTimeout(() => {
    const redirectPath = localStorage.getItem('redirectAfterReload');
    if (redirectPath) {
      localStorage.removeItem('redirectAfterReload');
      router.push(redirectPath);
    }
  }, 100);
});

// 路由守卫
router.beforeEach((to, from, next) => {
  let arr = store.getters.getpermission
  if (to.fullPath === '/home') {
    store.commit('addN')
  }
  if (to.fullPath === '/gl') {
    store.commit('addX')
  }
  if (to.fullPath === '/report') {
    store.commit('add3')
  }
  if (to.fullPath === '/guoGuanJuReport') {
    store.commit('add3')
  }
  if (to.fullPath === '/sjlr/manual') {
    store.commit('addY')
  }
  if (to.fullPath === '/sjlr/changecampu') {
    store.commit('addX')
  }
  if (to.fullPath === '/lurutable') {
    store.commit('addY')
  }
  if (to.fullPath === '/verify') {
    store.commit('flag1change', 1)
    store.commit('addY')
  }
  if (to.fullPath === '/sjgl') {
    store.commit('flag1change', 1)
  }
  if (to.fullPath === '/tableexamine') {
    if(localStorage.getItem('dataVerify') === 'true'){
      store.commit('add', 11)
    }else{
      store.commit('addY')
    }
  }
  if (to.fullPath === '/heduitable') {
    if(localStorage.getItem('dataVerify') === 'true'){
      store.commit('add', 11)
    }else{
      store.commit('addY')
    }
  }
  if (to.fullPath === '/heduitable303') {
    if(localStorage.getItem('dataVerify') === 'true'){
      store.commit('add', 11)
    }else{
      store.commit('addY')
    }
  }
  // 审核流程页面（tableexamine/heduitable/heduitable303）分两种模式校验：
  // 普通查看模式（dataVerify=false）走下方通用校验（meta.id=4，数据核对权限）即可；
  // 数据管理模式（dataVerify=true）额外要求"数据管理"权限（id 6），
  // 防止仅具备数据核对权限的用户篡改 localStorage 的 dataVerify 后越权进入审核页
  if (['/tableexamine', '/heduitable', '/heduitable303'].includes(to.path) &&
    localStorage.getItem('dataVerify') === 'true') {
    if (arr && arr.some((item) => item.id === 6)) {
      next()
    } else {
      MessageBox.alert('您没有访问数据审核页面的权限', '权限提示', {
        confirmButtonText: '确定',
        type: 'warning'
      }).then(() => {
        next({ path: '/home' })
      })
    }
  } else if (to.path === '/sjgl') {
    // 检查用户是否有权限访问/sjgl路径（meta.id为4）
    if (arr && arr.some((item) => item.id === 4)) {
      next()
    } else {
      // 无权限时给出提示并跳转到首页
      MessageBox.alert('您没有访问数据管理页面的权限', '权限提示', {
        confirmButtonText: '确定',
        type: 'warning'
      }).then(() => {
        next({ path: '/home' })
      })
    }
  } else {
    // 其他路径的正常权限检查
    // 添加安全检查，确保arr和to.meta存在
    if (arr && to.meta && ((arr.some((item) => {
      return item.id === to.meta.id
    }) || (to.meta.id === 0)))) {
      next()
    }
    else {
      // 允许访问error页面和meta.id为0的页面
      if (to.path === '/error' || (to.meta && to.meta.id === 0)) {
        next()
      }
      else {
        next({
          path: '/error'
        })
      }
    }
  }
})

function add(m) {
  return m < 10 ? "0" + m : m;
}
function format(shijianchuo) {
  //shijianchuo是整数，否则要parseInt转换
  var time = new Date(shijianchuo);
  var y = time.getFullYear();
  var m = time.getMonth() + 1;
  var d = time.getDate();
  return y + "-" + add(m) + "-" + add(d);
}

// Axios 拦截器配置
axios.interceptors.request.use(
  config => {
    if (config.url === '/basic/info/list' || config.url === '/statistics/by/item' || config.url === '/statistics/by/scope' || config.url === '/statistics/overview/by/scope/2022' || config.url === '/statistics/overview' || config.url === '/resource/university/code' || config.url === '/resource/city/code' || config.url === '/user/count' || config.url === '/resource/visit/count' || config.url === '/resource/news/list' || config.url === '/user/login') {

    }
    else {
      config.headers['X-Token'] = `${store.getters.token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
)

let flag = true
axios.interceptors.response.use(function (response) {
  return response
}, function (error) {
  // 添加错误响应检查，防止读取undefined属性
  if (!error.response) {
    console.error('Network error or no response:', error.message)
    return Promise.reject(error)
  }
  
  if (error.response.status === 401) {
    if (flag === true) {
      flag = false
      // 无论loginid是什么值，只要遇到401错误，都显示登录提示并跳转到首页
      MessageBox.confirm(
        "长时间未操作，请重新登录",
        "提示",
        {
          confirmButtonText: '确定',
          showCancelButton: false,
          closeOnClickModal: false,
          type: 'warning'
        }
      ).then(() => {
        flag = true
        store.commit("userFlag", 0);
        store.commit("GetToken", "");
        store.commit("Getexpiretime", 0);
        store.commit("HomeUserName", "");
        store.commit("HomeSchoolName", "");
        store.commit("showshezhi", false);
        store.commit("Getpermission", [
          {
            description: "",
            id: 1,
            name: "首页",
          },
        ]);
        router.push('/home')
      })
    }
  }
  else if (error.response.status === 404) {
    console.error('API endpoint not found:', error.config.url);
    // 可以在这里添加用户友好的提示
    // Message.warning('请求的资源不存在');
  }
  else if (error.response.status === 400 && error.config && error.config.url === '/user/apply/account') {
    store.commit('codema', error.response.data.code)
  }
  
  return Promise.reject(error)
})
